module.exports = __webpack_public_path__ + "img/danger-status.ee3bdfe1.svg";